import { render, staticRenderFns } from "./Gramification.vue?vue&type=template&id=1449088c&"
import script from "./Gramification.vue?vue&type=script&lang=js&"
export * from "./Gramification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports